import {menusNavigation} from './store';

const menus = menusNavigation.allMenus;

const views = {};

Object.keys(menus).forEach(tab => {
  const name = menus[tab];
  views[menus[tab]] = () => import(`@/views/${name}.vue`);
});
export default views;
